import * as React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

type Props = {
  selectedDriversAmount: number
  totalDriversAmount: number
  selectedVehiclesAmount: number
  totalVehiclesAmount: number
}

export const SelectedSummary = ({
  selectedDriversAmount,
  totalDriversAmount,
  selectedVehiclesAmount,
  totalVehiclesAmount,
}: Props) => {
  const { t } = useLocalize()
  return (
    <p className="tw-text-xs tw-text-slate-600">
      {t('importModule.marked')}{' '}
      <span className="tw-font-semibold">{selectedDriversAmount}</span>/
      {totalDriversAmount} {t('importModule.drivers-and')}{' '}
      <span className="tw-font-semibold">{selectedVehiclesAmount}</span>/
      {totalVehiclesAmount} {t('importModule.vehicles-dot')}
    </p>
  )
}
